<footer class="flex flex-row justify-between items-center px-2 py-2 px-4 w-full bg-white border-gray-200 border-t">
    <div class="flex flex-row items-center">
        <a class="w-32 inline-block mr-8" routerLink="/dashboard">
            <img alt="RKSH Regjistri i kafshëve shtëpiake" class="max-w-full !relative !h-auto" height="50"
                src="https://ctvmngvzsmtrbqckpgxq.supabase.co/storage/v1/object/public/assets/logo-small.png"
                width="128">
        </a>
        <p class="flex flex-row">
            <span class="mr-4">Contact email</span>
            <a class="underline hover:text-red-600 duration-200" href="mailto:info@rksh.al">info@rksh.al</a>
        </p>
    </div>
    <ul>
        <li>
            <a class="hover:text-red-600 duration-200" routerLink="/dashboard/terms">{{ "terms.pageTitle" | translate }}</a>
        </li>
        <li>
            <a class="hover:text-red-600 duration-200" routerLink="/dashboard/privacy-policy">{{ "privacy.pageTitle" | translate }}</a>
        </li>
    </ul>
</footer>
